import React from 'react';

interface StatusDistributionCardProps {
  totalBooks: number;
  statusCounts: Record<string, number>;
}

export const StatusDistributionCard: React.FC<StatusDistributionCardProps> = ({
  totalBooks,
  statusCounts,
}) => {
  return (
    <div className="bg-white p-5 rounded-2xl border border-slate-200/90 shadow-2xs space-y-4">
      <div>
        <h3 className="text-sm font-bold text-slate-900">Distribusi Status Buku</h3>
        <p className="text-xs text-slate-500">Kesiapan publikasi katalog</p>
      </div>

      <div className="space-y-3 pt-2">
        <div>
          <div className="flex justify-between text-xs mb-1">
            <span className="text-slate-600 font-medium">Disetujui / Aktif Resmi</span>
            <span className="font-bold text-emerald-700">{statusCounts.disetujui}</span>
          </div>
          <div className="h-2 w-full bg-slate-100 rounded-full overflow-hidden">
            <div
              className="h-full bg-emerald-500"
              style={{ width: `${totalBooks > 0 ? (statusCounts.disetujui / totalBooks) * 100 : 0}%` }}
            />
          </div>
        </div>

        <div>
          <div className="flex justify-between text-xs mb-1">
            <span className="text-slate-600 font-medium">Diajukan (Review)</span>
            <span className="font-bold text-amber-600">{statusCounts.diajukan}</span>
          </div>
          <div className="h-2 w-full bg-slate-100 rounded-full overflow-hidden">
            <div
              className="h-full bg-amber-500"
              style={{ width: `${totalBooks > 0 ? (statusCounts.diajukan / totalBooks) * 100 : 0}%` }}
            />
          </div>
        </div>

        <div>
          <div className="flex justify-between text-xs mb-1">
            <span className="text-slate-600 font-medium">Ditolak / Perlu Revisi</span>
            <span className="font-bold text-rose-600">{statusCounts.ditolak || 0}</span>
          </div>
          <div className="h-2 w-full bg-slate-100 rounded-full overflow-hidden">
            <div
              className="h-full bg-rose-500"
              style={{ width: `${totalBooks > 0 ? ((statusCounts.ditolak || 0) / totalBooks) * 100 : 0}%` }}
            />
          </div>
        </div>

        <div>
          <div className="flex justify-between text-xs mb-1">
            <span className="text-slate-600 font-medium">Draft Naskah</span>
            <span className="font-bold text-slate-600">{statusCounts.draft}</span>
          </div>
          <div className="h-2 w-full bg-slate-100 rounded-full overflow-hidden">
            <div
              className="h-full bg-slate-400"
              style={{ width: `${totalBooks > 0 ? (statusCounts.draft / totalBooks) * 100 : 0}%` }}
            />
          </div>
        </div>

        <div>
          <div className="flex justify-between text-xs mb-1">
            <span className="text-slate-600 font-medium">Diarsipkan</span>
            <span className="font-bold text-stone-600">{statusCounts.diarsipkan}</span>
          </div>
          <div className="h-2 w-full bg-slate-100 rounded-full overflow-hidden">
            <div
              className="h-full bg-stone-400"
              style={{ width: `${totalBooks > 0 ? (statusCounts.diarsipkan / totalBooks) * 100 : 0}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
